import * as React from 'react';
import { default as GridLineHeader, GridLineHeaderClassNames } from './GridLineHeader';
import { ItemsLayout } from '../interfaces/ItemsLayout';
import { SurfaceStore } from 'owa-calendar-surface-core';
import GridLinesFragment from './GridLinesFragment';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';

/** Renders the set of grid line headers, containing the times of the day. */
export function GridLineHeaders({
    store,
    itemsLayout,
    classNames,
    timeZoneId,
    showIsNewDay,
}: {
    store: SurfaceStore;
    itemsLayout: ItemsLayout;
    classNames?: GridLineHeaderClassNames;
    timeZoneId?: string;
    showIsNewDay: boolean;
}) {
    return (
        <GridLinesFragment
            itemType={GridLineHeader}
            itemClassNames={classNames}
            itemsLayout={itemsLayout}
            intervalInMinutes={TimeConstants.MinutesInOneHour}
            store={store}
            timeZoneId={timeZoneId}
            showIsNewDay={showIsNewDay}
        />
    );
}
